module.exports = __webpack_public_path__ + "img/2-2.51a3bc08.png";